import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Divider, Typography, Badge, Drawer, List, Avatar, Empty } from 'antd'
import {
    SearchOutlined, DownOutlined, CloseOutlined, QrcodeOutlined,
    GlobalOutlined, ShoppingCartOutlined, DollarCircleFilled,
    FacebookOutlined, TwitterOutlined, LinkedinOutlined,
    InstagramOutlined, GithubOutlined,
} from '@ant-design/icons'
import {
    MdSchool, MdCardMembership, MdVerifiedUser, MdTrendingUp, MdBusiness,
    MdComputer, MdLocalHospital, MdBusinessCenter, MdShowChart, MdInfo,
    MdFlag, MdWork, MdStar, MdLiveHelp
} from 'react-icons/md'
import styled, { createGlobalStyle } from 'styled-components'
import { useHistory, Link } from 'react-router-dom'

const { Text, Paragraph } = Typography

export const GlobalPageStyle = createGlobalStyle`
  body {
    background: #fff; margin: 0; padding: 0;
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    color: #333;
  }
`
const AppPromoBanner = styled.div`
  background-color: #fff3e0;
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 24px; font-size: 14px; color: #111; font-weight: 500;
  position: relative; z-index: 1001;
  .promo-text { flex: 1; text-align: center; }
  .promo-actions { display: flex; align-items: center; gap: 16px; }
  @media (max-width: 768px) { display: none; }
`
export const MainHeaderContainer = styled.header`
  background: #ffffff; border-bottom: 1px solid #e0e0e0;
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 24px; height: 72px; position: sticky; top: 0; z-index: 1000;
  @media (max-width: 768px) { padding: 12px 16px; }
`
export const HeaderLeft = styled.div`
  display: flex; align-items: center; gap: 24px;
`
export const HeaderSearchBox = styled.div`
  display: flex; border: 1px solid #ccc; border-radius: 4px;
  overflow: hidden; height: 40px; width: 280px;
  input { border: none; padding: 0 12px; flex: 1; outline: none; font-size: 14px; }
  button {
    background: #6c757d; border: none; color: white; width: 44px; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    &:hover { background: #5a6268; }
  }
  @media (max-width: 1024px) { display: none; }
`
export const HeaderNav = styled.nav`
  display: flex; align-items: center; gap: 16px; font-size: 13px; color: #555;
  a {
    color: #555; font-weight: 600; text-decoration: none;
    display: flex; align-items: center; gap: 4px; transition: color 0.2s;
    &:hover { color: hsl(210, 55%, 22%); }
    &.active { color: hsl(210,55%,22%); }
  }
  .divider { width: 1px; height: 24px; background: #e0e0e0; margin: 0 8px; }
  @media (max-width: 1024px) { display: none; }
`
export const FreeLmsBadge = styled.div`
  border: 1px solid hsl(210, 55%, 22%); color: hsl(210, 55%, 22%);
  font-weight: 800; font-size: 11px; padding: 4px 8px; border-radius: 4px;
`
export const HeaderRight = styled.div`
  display: flex; align-items: center; gap: 16px;
  .icon-btn { font-size: 18px; color: #555; cursor: pointer; &:hover { color: hsl(210, 55%, 22%); } }
`
const UpskillBanner = styled.div`
  background: hsl(210, 55%, 22%); color: white;
  display: flex; justify-content: center; align-items: center;
  padding: 12px 24px; gap: 24px; position: relative; font-weight: 600; font-size: 16px;
  .close-icon { position: absolute; right: 24px; cursor: pointer; font-size: 16px; }
`
export const FooterWrapper = styled.footer`
  font-family: 'Poppins', sans-serif !important;
`

export const TopFooterBar = styled.div`
  background: hsl(33, 100%, 50%);
  padding: 40px 24px;
  display: flex;
  justify-content: center;
  border-bottom: 2px solid rgba(0,0,0,0.05);

  .container {
    max-width: 1200px;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    @media (max-width: 768px) { grid-template-columns: 1fr; gap: 40px; text-align: center; }
  }

  .col {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: #1a1a1a;
    position: relative;
    
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      right: -10px;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 60px;
      background: rgba(0, 0, 0, 0.1);
      @media (max-width: 768px) { display: none; }
    }
  }

  h5 {
    font-weight: 800;
    font-size: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 12px;
    color: #111;
  }

  p {
    font-size: 14px;
    margin: 0;
    line-height: 1.5;
    font-weight: 500;
  }

  .contact-btn {
    border: 2px solid white;
    background: transparent;
    color: white;
    padding: 8px 32px;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
    &:hover { background: white; color: hsl(33, 100%, 50%); }
  }
`

export const MainFooter = styled.div`
  background: #151a1e;
  padding: 80px 40px;
  display: flex;
  justify-content: center;

  .container {
    max-width: 1280px;
    width: 100%;
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr;
    gap: 40px;
    @media (max-width: 1024px) { grid-template-columns: 1fr 1fr; }
    @media (max-width: 768px) { grid-template-columns: 1fr; }
  }
`

export const FooterBrandCol = styled.div`
  .logo-area {
    margin-bottom: 24px;
    img { height: 60px; }
  }
  .brand-name {
    font-size: 32px;
    font-weight: 900;
    color: white;
    letter-spacing: -1px;
    line-height: 1;
    margin-bottom: 8px;
  }
  .desc {
    color: #94a3b8;
    line-height: 1.6;
    font-size: 14px;
  }
`

export const FooterLinkCol = styled.div`
  h4 {
    color: white;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 24px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
      content: ']';
      color: hsl(33, 100%, 50%);
      font-size: 20px;
      font-weight: 900;
      transform: scaleX(1.5);
      display: inline-block;
    }
  }

  ul { list-style: none; padding: 0; margin: 0; }
  li { margin-bottom: 12px; }
  a {
    color: white;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
    &:hover { color: hsl(33, 100%, 50%); padding-left: 4px; }
  }
`

export const BottomStrip = styled.div`
  background: #000;
  padding: 20px 40px;
  border-top: 1px solid rgba(255,255,255,0.05);

  .container {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 768px) { flex-direction: column; gap: 10px; text-align: center; }
  }

  .copy { color: #64748b; font-size: 12px; }
  .legal {
    display: flex;
    gap: 20px;
    a { color: #64748b; font-size: 12px; text-decoration: none; &:hover { color: hsl(33, 100%, 50%); } }
  }
`

/**
 * Shared public page layout: header banners + sticky nav + footer.
 * Pass `activeLink` as 'courses' | 'careers' | other to highlight the nav.
 * `children` is the page body.
 */
const PublicPageLayout = ({ children, activeLink = '' }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { isAuth } = useSelector(s => s.auth)
    const cart = useSelector(s => s.cart)
    const [showPromo, setShowPromo] = useState(true)
    const [showUpskill, setShowUpskill] = useState(true)
    const [searchQuery, setSearchQuery] = useState('')
    const [isCartOpen, setIsCartOpen] = useState(false)

    const handleSearch = (e) => {
        e.preventDefault()
        history.push({ pathname: '/explore-courses', state: { query: searchQuery } })
    }

    return (
        <>
            <GlobalPageStyle />

            {showPromo && (
                <AppPromoBanner>
                    <div className="promo-text">
                        Discover the WISE App  seamless, accelerated learning designed for your on the go lifestyle...
                    </div>
                    <div className="promo-actions">
                        <Button style={{ borderRadius: 20, fontWeight: 600, borderColor: '#aaa' }} icon={<QrcodeOutlined />}>Get App</Button>
                        <CloseOutlined style={{ cursor: 'pointer', fontSize: 16 }} onClick={() => setShowPromo(false)} />
                    </div>
                </AppPromoBanner >
            )}

            <MainHeaderContainer>
                <HeaderLeft>
                    <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
                        <img src="/logo512.png" alt="Logo" style={{ height: 40 }} />
                    </Link>
                    <HeaderSearchBox as="form" onSubmit={handleSearch}>
                        <input type="text" placeholder="What do you want to learn?" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
                        <button type="submit"><SearchOutlined /></button>
                    </HeaderSearchBox>
                    <HeaderNav>
                        <Link to="/explore-courses" className={activeLink === 'courses' ? 'active' : ''}>
                            Explore Courses <DownOutlined style={{ fontSize: 10 }} />
                        </Link>
                        <Link to="/about" className={activeLink === 'about' ? 'active' : ''}>
                            About <DownOutlined style={{ fontSize: 10 }} />
                        </Link>
                        <Link to="/app/articles">More <DownOutlined style={{ fontSize: 10 }} /></Link>
                        {/* <DollarCircleFilled style={{ color: '#f39c12', fontSize: 24 }} /> */}
                    </HeaderNav>
                </HeaderLeft>
                <HeaderRight>
                    {isAuth ? (
                        <Link to="/app">
                            <Button type="primary" style={{ background: 'hsl(33,100%,50%)', borderColor: 'hsl(33,100%,50%)', borderRadius: 4 }}>Dashboard</Button>
                        </Link>
                    ) : (
                        <>
                            <Link to="/login" style={{ color: '#555', fontWeight: 600, textDecoration: 'none' }}>Log In</Link>
                            <Link to="/register">
                                <Button type="primary" style={{ background: 'hsl(33,100%,50%)', borderColor: 'hsl(33,100%,50%)', borderRadius: 4 }}>Sign Up</Button>
                            </Link>
                        </>
                    )}
                    <GlobalOutlined className="icon-btn" style={{ marginLeft: 8 }} />
                    <Badge count={cart.length} offset={[8, -2]}>
                        <ShoppingCartOutlined className="icon-btn" onClick={() => setIsCartOpen(true)} />
                    </Badge>
                </HeaderRight>
            </MainHeaderContainer>

            <Drawer
                title={<div style={{ fontSize: 20, fontWeight: 800 }}>Your Cart ({cart.length})</div>}
                placement="right"
                onClose={() => setIsCartOpen(false)}
                visible={isCartOpen}
                width={Math.min(420, window.innerWidth)}
            >
                {cart.length > 0 ? (
                    <>
                        <List
                            itemLayout="horizontal"
                            dataSource={cart}
                            renderItem={item => (
                                <List.Item
                                    actions={[<Button type="link" danger onClick={() => dispatch({ type: 'REMOVE_FROM_CART', data: item.id })}>Remove</Button>]}
                                >
                                    <List.Item.Meta
                                        avatar={<Avatar shape="square" size={64} src={item.image || '/logo192.png'} />}
                                        title={<span style={{ fontWeight: 700 }}>{item.name}</span>}
                                        description={<span style={{ color: '#2e7d32', fontWeight: 600 }}>{item.type || 'Course'} • Free Enrollment</span>}
                                    />
                                </List.Item>
                            )}
                        />
                        <div style={{ marginTop: 24, padding: '20px 0', borderTop: '1px solid #eee' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                                <Text strong style={{ fontSize: 18 }}>Total Price:</Text>
                                <Text strong style={{ fontSize: 18, color: '#111' }}>Free</Text>
                            </div>
                            <Button
                                type="primary"
                                size="large"
                                block
                                style={{ height: 50, background: 'hsl(33, 100%, 50%)', borderColor: 'hsl(33, 100%, 50%)', fontWeight: 800 }}
                                onClick={() => {
                                    setIsCartOpen(false)
                                    if (isAuth) {
                                        history.push('/app/courses')
                                    } else {
                                        history.push('/login')
                                    }
                                }}
                            >
                                {isAuth ? 'Complete Enrollment' : 'Login to Enroll'}
                            </Button>
                        </div>
                    </>
                ) : (
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <Empty description="Your cart is currently empty." />
                        <Button type="primary" style={{ marginTop: 24, borderRadius: 20 }} onClick={() => { setIsCartOpen(false); history.push('/explore-courses') }}>Browse Courses</Button>
                    </div>
                )}
            </Drawer>

            {
                showUpskill && (
                    <UpskillBanner>
                        Looking to upskill your entire organization at no cost?
                        <Button onClick={() => history.push('/register')} style={{ borderRadius: 20, fontWeight: 600, color: 'hsl(210,55%,22%)' }}>Discover How!</Button>
                        <CloseOutlined className="close-icon" onClick={() => setShowUpskill(false)} />
                    </UpskillBanner>
                )
            }

            {children}

            <FooterWrapper>
                <TopFooterBar>
                    <div className="container">
                        <div className="col">
                            <h5>ADDRESS</h5>
                            <p>KN 3 Rd, Kigali</p>
                            <p>City Center, Rwanda</p>
                        </div>
                        <div className="col">
                            <h5>CONTACT</h5>
                            <p>+250 788 000 000</p>
                            <p>wiseacademyrw@gmail.com</p>
                        </div>
                        <div className="col">
                            <h5>HOURS</h5>
                            <p>Monday to Friday</p>
                            <p>8 AM to 12 PM & 2 PM to 6 PM</p>
                        </div>
                        <div className="col">
                            <h5>INQUIRIES</h5>
                            <button className="contact-btn" onClick={() => history.push('/contact')}>Contact</button>
                        </div>
                    </div>
                </TopFooterBar>

                <MainFooter>
                    <div className="container">
                        <FooterBrandCol>
                            <div className="logo-area">
                                <img src="/logo512.png" alt="Logo" />
                            </div>
                            <p className="desc">
                                Empowering Rwanda through accessible, high-quality online education.
                                Join our mission to build a skilled community.
                            </p>
                            <div style={{ display: 'flex', gap: 16, marginTop: 24, fontSize: 20 }}>
                                <FacebookOutlined style={{ color: '#fff', cursor: 'pointer' }} />
                                <TwitterOutlined style={{ color: '#fff', cursor: 'pointer' }} />
                                <GithubOutlined style={{ color: '#fff', cursor: 'pointer' }} />
                            </div>
                        </FooterBrandCol>

                        <FooterLinkCol>
                            <h4>Navigation</h4>
                            <ul>
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/about">Our Mission</Link></li>
                                <li><Link to="/careers">Careers</Link></li>
                                <li><Link to="/success-stories">Success Stories</Link></li>
                                <li><Link to="/contact">Contact Us</Link></li>
                            </ul>
                        </FooterLinkCol>

                        <FooterLinkCol>
                            <h4>Our Products</h4>
                            <ul>
                                <li><Link to="/diplomas">Diplomas</Link></li>
                                <li><Link to="/certificates">Certificates</Link></li>
                                <li><Link to="/skill-paths">Skill Paths</Link></li>
                                <li><Link to="/corporate-training">Corporate Training</Link></li>
                            </ul>
                        </FooterLinkCol>

                        <FooterLinkCol>
                            <h4>Categories</h4>
                            <ul>
                                <li><Link to="/category/computer-science">Computer Science</Link></li>
                                <li><Link to="/category/health">Health</Link></li>
                                <li><Link to="/category/business">Business</Link></li>
                                <li><Link to="/category/marketing">Marketing</Link></li>
                            </ul>
                        </FooterLinkCol>

                        <FooterLinkCol>
                            <h4>Download App</h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" width="130" style={{ cursor: 'pointer', filter: 'brightness(1.5)' }} />
                                <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Play Store" width="130" style={{ cursor: 'pointer', filter: 'brightness(1.5)' }} />
                            </div>
                        </FooterLinkCol>
                    </div>
                </MainFooter>

                <BottomStrip>
                    <div className="container">
                        <div className="copy">Copyright © 2026 - Wise Academy Rwanda. All rights reserved.</div>
                        <div className="legal">
                            <Link to="/privacy">Privacy Policy</Link>
                            <Link to="/terms">Terms of Use</Link>
                        </div>
                    </div>
                </BottomStrip>
            </FooterWrapper>
        </>
    )
}

export default PublicPageLayout
